import React from 'react';
import { Button, Content } from '@leverege/ui-elements';
import { ValueCache } from '@leverege/value-cache';
import { TitleBar } from '@leverege/ui-plugin';
import { Users } from '@leverege/api-redux';
import { GlobalState } from '@leverege/ui-redux';
import merge from 'deepmerge';
import I18N from '@leverege/i18n';
import OneTimeCodes from "./OneTimeCodes.js";
import LoginModal from "./LoginModal.js";
const {
  t
} = I18N.ns('login.twoFactor.ViewCodesFlow');
export default class ViewCodesFlow extends React.Component {
  constructor(props) {
    super(props);
    this.flowCache = new ValueCache();
    this.state = {
      step: 0,
      password: null,
      error: null,
      oneTimeCodes: {}
    };
  }
  onRequestCodes = async () => {
    const {
      profile
    } = this.props;
    const {
      password,
      step
    } = this.state;
    try {
      const {
        codes: oneTimeCodes
      } = await GlobalState.dispatch(Users.getOneTimeLoginCodes(profile.id, password));
      this.setState({
        oneTimeCodes,
        step: step + 1
      });
    } catch (err) {
      this.setState({
        error: err.message
      });
    }
  };
  onGenerateNewCodes = async () => {
    const {
      profile
    } = this.props;
    const {
      password
    } = this.state;
    try {
      const {
        codes: oneTimeCodes
      } = await GlobalState.dispatch(Users.regenerateOneTimeLoginCodes(profile.id, password));
      this.setState({
        oneTimeCodes
      });
    } catch (err) {
      this.setState({
        error: err.message
      });
    }
  };
  getFlow = () => {
    const {
      title,
      icon,
      onClose,
      headerVariant,
      contentVariant,
      footerVariant
    } = this.props;
    const {
      oneTimeCodes,
      password,
      error
    } = this.state;
    return this.flowCache.calc(props => {
      return {
        defaults: {
          header: {
            render: () => {
              return /*#__PURE__*/React.createElement(TitleBar, {
                variant: "twoStepDialogTitle|dialogTitle",
                title: title,
                icon: icon
              });
            },
            variant: headerVariant
          },
          content: {
            variant: contentVariant,
            layout: 'flex:colM'
          },
          footer: {
            variant: footerVariant,
            layout: 'flex:rowMEnd'
          }
        },
        steps: [{
          id: 'enterPassword',
          content: {
            component: LoginModal,
            props: {
              onChange: ({
                value
              }) => this.setState({
                password: value
              }),
              variant: 'loginWarning',
              password,
              error
            }
          },
          footer: {
            render: () => {
              return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
                variant: "primaryCancel",
                onClick: onClose
              }, t('cancel')), /*#__PURE__*/React.createElement(Button, {
                disabled: password == null || password === '',
                variant: "primary",
                type: "submit",
                onClick: this.onRequestCodes
              }, t('next')));
            }
          }
        }, {
          id: 'viewOneTimeCodes',
          content: {
            component: OneTimeCodes,
            props: {
              oneTimeCodes
            }
          },
          footer: {
            render: () => {
              return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
                variant: "primaryCancel",
                onClick: this.onGenerateNewCodes
              }, t('newCodes')), /*#__PURE__*/React.createElement(Button, {
                variant: "primary",
                onClick: onClose
              }, t('close')));
            }
          }
        }]
      };
    }, this.props, this.state);
  };
  getStepData = () => {
    const {
      step
    } = this.state;
    const flow = this.getFlow();
    return merge(flow.defaults, flow.steps[step], {
      arrayMerge: overwriteMerge
    });
  };
  renderStep(step) {
    const stepData = this.getStepData();
    const {
      header,
      content,
      footer
    } = stepData;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Content.Header, {
      variant: header.variant,
      layout: header.layout
    }, renderStepSection(header)), /*#__PURE__*/React.createElement(Content.Area, {
      variant: content.variant,
      layout: content.layout
    }, renderStepSection(content)), /*#__PURE__*/React.createElement(Content.Footer, {
      variant: footer.variant,
      layout: footer.layout
    }, renderStepSection(footer)));
  }
  render() {
    const {
      mobile
    } = this.props;
    const {
      step
    } = this.state;
    return /*#__PURE__*/React.createElement(Content, {
      relative: !mobile
    }, this.renderStep(step));
  }
}
function renderStepSection(section) {
  const {
    component: Component,
    render
  } = section;
  if (Component) {
    return /*#__PURE__*/React.createElement(Component, section.props);
  }
  if (render) {
    return render(section.props);
  }
  return null;
}
function overwriteMerge(dest, source) {
  return source;
}